import React, { useState } from 'react'
import { Card, Form, Table, Col } from 'antd'
import moment from 'moment-jalaali';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from '../helpers/ValidatorHelper';
import { useReportsStore } from '../../store/slices/createReportsSlice';
import strings from '../../utils/strings';

const columns = [
    {
        title: 'شناسه',
        dataIndex: 'Id',
        key: "Id",
        width: 100,
    },
    {
        title: 'مبلغ(ریال)',
        dataIndex: 'Amount',
        key: 'Amount',
        width: 100,
        render: data => (data || data === 0) ? strings.currencyFormat(data) : data,
    },
    {
        title: 'زمان ایجاد',
        dataIndex: 'CreationTime',
        key: 'CreationTime',
        width: 185,
    },
    {
        title: 'شماره الحاقیه',
        dataIndex: 'EndorsementId',
        key: 'EndorsementId',
        width: 100,
        render: EndorsementId => (EndorsementId === 0 || EndorsementId === null) ? '' : EndorsementId,
    },
    {
        title: 'شناسه درخواست',
        dataIndex: 'InsuranceRequestId',
        key: 'InsuranceRequestId',
        width: 120,
    },
    {
        title: 'شناسه وضعیت درخواست',
        dataIndex: 'InsuranceRequestStatusId',
        key: 'InsuranceRequestStatusId',
        width: 100,
    },
    {
        title: 'وضعیت درخواست',
        dataIndex: 'InsuranceRequestStatusTitle',
        key: 'InsuranceRequestStatusTitle',
        width: 200,
    },
    {
        title: 'شناسه کسب و کار',
        dataIndex: 'BusinessId',
        key: 'BusinessId',
        width: 100,
    },
    {
        title: 'کسب و کار',
        dataIndex: 'BusinessTitle',
        key: 'BusinessTitle',
        width: 150,
    },
    {
        title: 'نام و نام خانوادگی',
        dataIndex: 'FullName',
        key: 'FullName',
        width: 185,
    },
    {
        title: 'شماره همراه کاربر',
        dataIndex: 'MobileNumber',
        key: 'MobileNumber',
        width: 150,
    },
    {
        title: 'شماره شبا',
        dataIndex: 'IBAN',
        key: 'IBAN',
        width: 250,
    },
    {
        title: 'شناسه کاربر',
        dataIndex: 'UserId',
        key: 'UserId',
        width: 100,
    },
    {
        title: 'اطلاعات ناقص',
        dataIndex: 'IsRed',
        key: 'IsRed',
        width: 150,
    },
    {
        title: 'شناسه کاربر سازنده',
        dataIndex: 'CreatorUserId',
        key: 'CreatorUserId',
        width: 100,
    },
    {
        title: 'کاربر سازنده',
        dataIndex: 'CreatorFullName',
        key: 'CreatorFullName',
        width: 150,
    },
    {
        title: 'نوع صاحب حساب',
        dataIndex: 'GatewayOwnType',
        key: 'GatewayOwnType',
        width: 100,
    },
    {
        title: 'عنوان درگاه',
        dataIndex: 'GatewayTitle',
        key: 'GatewayTitle',
        width: 150,
    },
];

const ReturnedReports = () => {
    const reports = useReportsStore()
    const returnedPaidToUserReports = reports.returnedReports.returnedPaidToUserReports
    const loading = reports.returnedReports.loading
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        const params = {
            fromDate: convertToMoment(fromDate), // moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: convertToMoment(toDate) //moment(values.toDate).format('YYYY-MM-DD')
        }
        reports.getPaidToUserReturnedReports({ param: params });
    }

    return (
        <Card>
            <Col style={{
                display: "flex",
                gap: 20,
                marginBottom: 16,
                justifyContent: "space-between",
                alignItems: "center"
            }} xs={24}>
                <div style={{ fontSize: 16 }}>گزارش عودتی‌های مالی</div>

            </Col>

            <div style={{ fontSize: 14, marginBottom: 16 }}>بازه تاریخی مربوطه را انتخاب نمایید</div>


            <Form
                onFinish={onFinish}
                layout="inline"
            >
                <Form.Item
                    rules={ValidatorHelper.required("تاریخ")}
                    style={{ width: "220px" }}
                    name='fromDate'
                    label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item
                    rules={ValidatorHelper.required("تاریخ")}
                    style={{ width: "220px" }}
                    name='toDate'
                    label='تا تاریخ'>
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <button
                    style={{
                        float: "left",
                        padding: "0 10px",
                        height: 33,
                    }}
                    disabled={loading} type="primary"
                    className="btn btn-primary waves-effect waves-light" htmltype="submit">جستجو&nbsp;&nbsp;&nbsp;
                    <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                </button>
            </Form>
            <div>

                <Table
                    scroll={{ x: 'max-content' }}
                    size="small"
                    className="custom-table"
                    loading={loading}
                    bordered
                    rowKey="Id"
                    columns={columns}
                    dataSource={returnedPaidToUserReports ? [...returnedPaidToUserReports].sort((a, b) => b.Id - a.Id) : []}
                    rowClassName={(record) => ((record.EndorsementId === 0 || record.EndorsementId === null) ? "none" : "highlight")}
                />
            </div>
            {/* <WaitingSettlementReports loading={loading} /> */}
        </Card>
    )
}

export default ReturnedReports
